import { render, staticRenderFns } from "./MainNotifications.vue?vue&type=template&id=1f9f33f3&scoped=true&"
import script from "./MainNotifications.vue?vue&type=script&lang=js&"
export * from "./MainNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MainNotifications.vue?vue&type=style&index=0&id=1f9f33f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f33f3",
  null
  
)

export default component.exports